// @ts-nocheck
const log = (message) => {
    console.log('%cVERBOS: ', 'color:#006699;', message);
}

export default log;